import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/solutions', label: 'Solutions' },
    { path: '/devis', label: 'Demander un devis' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="network-header">
      <div className="nav-wrapper">
        <div className="nav-left">
          <Link to="/" className="network-logo" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <img 
              src="/logo.jpeg" 
              alt="Nouveau Départ Logo"
              style={{ height: '40px', width: 'auto' }}
            />
            <span>Nouveau Départ</span>
          </Link>
          
          <div className="contact-buttons">
            <a href="tel:0175438580" className="contact-btn">
              <Phone size={16} />
              <span>01 75 43 85 80</span>
            </a>
            <a href="mailto:contact@nvdepart.fr" className="contact-btn">
              <Mail size={16} />
              <span className="email-text">contact@nvdepart.fr</span>
            </a>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="network-nav-link"
              style={{
                background: isActive(link.path) ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
              }}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && (
        <div className="mobile-menu">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="mobile-nav-link"
              onClick={() => setIsMenuOpen(false)}
              style={{
                background: isActive(link.path) ? 'rgba(255, 255, 255, 0.15)' : 'transparent',
              }}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}

      <style>{`
        .network-header {
          background: transparent;
          position: absolute;
          top: 32px;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 99999;
          padding: 0 12px;
        }

        .nav-wrapper {
          max-width: 1440px;
          margin: 0 auto;
          background: var(--brand-dark);
          border-radius: 25px;
          padding: 8px 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-shadow: 0 2px 8px rgba(0, 69, 52, 0.25);
        }

        .nav-left {
          display: flex;
          align-items: center;
          gap: 24px;
        }

        .network-logo {
          font-size: 18px;
          font-weight: 600;
          color: white;
          text-decoration: none;
        }

        .contact-buttons {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .contact-btn {
          display: flex;
          align-items: center;
          gap: 6px;
          background: rgba(255, 255, 255, 0.1);
          color: white;
          text-decoration: none;
          font-size: 14px;
          font-weight: 500;
          padding: 6px 12px;
          border-radius: 20px;
          transition: all 0.2s ease;
        }

        .contact-btn:hover {
          background: rgba(255, 255, 255, 0.2);
        }

        .desktop-nav {
          display: flex;
          align-items: center;
          gap: 24px;
        }

        .network-nav-link {
          color: white;
          text-decoration: none;
          font-size: 16px;
          font-weight: 500;
          padding: 8px 16px;
          border-radius: 20px;
          transition: all 0.2s ease;
        }

        .network-nav-link:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        .mobile-menu-btn {
          display: none;
          background: none;
          border: none;
          color: white;
          cursor: pointer;
          padding: 8px;
        }

        .mobile-menu {
          display: none;
        }

        @media (max-width: 1100px) {
          .contact-btn {
            font-size: 13px;
            padding: 6px 10px;
          }
        }

        @media (max-width: 768px) {
          .network-header {
            top: 0;
            position: fixed;
            padding: 0;
          }

          .nav-wrapper {
            border-radius: 0;
            padding: 12px 16px;
          }

          .nav-left {
            gap: 8px;
          }

          .network-logo span {
            display: none;
          }

          .contact-buttons {
            gap: 6px;
          }

          .contact-btn {
            font-size: 11px;
            padding: 6px 8px;
          }

          .desktop-nav {
            display: none !important;
          }

          .mobile-menu-btn {
            display: block !important;
          }

          .mobile-menu {
            display: block !important;
            background: var(--brand-dark);
            margin: 0;
            padding: 8px 16px 16px;
            border-bottom-left-radius: 16px;
            border-bottom-right-radius: 16px;
          }

          .mobile-nav-link {
            display: block;
            color: white;
            text-decoration: none;
            font-size: 16px;
            font-weight: 500;
            padding: 14px 16px;
            border-radius: 12px;
            transition: all 0.2s ease;
          }

          .mobile-nav-link:hover {
            background: rgba(255, 255, 255, 0.1);
          }
        }

        @media (max-width: 480px) {
          .contact-btn span.email-text {
            display: none;
          }
        }
      `}</style>
    </header>
  );
};

export default Navbar;
